"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaybackConverter = void 0;
const index_1 = __importDefault(require("../../../dayjs/index"));
const convertLinks_1 = require("../utils/convertLinks");
class PlaybackConverter {
    static convert(entity) {
        return {
            id: entity.id,
            type: entity.type,
            duration: index_1.default.duration(entity.duration),
            maxResolutionAvailable: entity.maxResolutionAvailable,
            links: (0, convertLinks_1.convertLinks)(entity),
        };
    }
}
exports.PlaybackConverter = PlaybackConverter;
//# sourceMappingURL=PlaybackConverter.js.map